import gql from "graphql-tag";

export const uploadedCollectionData = gql`
  mutation uploadedCollectionData(
    $input: UploadedCollectionInput!) {
    uploadedCollectionData(input: $input) {
      project {
        id
        updatedAt
        collections {
          id
          index
          syncing
          syncedAt
          encoding
          encodedAt
          changed
          changedAt
        }
      }
    }
  }
`;

export const uploadedCollectionDataOptions = {
  name: "uploadedCollectionData",
};
